/**
 * Externe Ports & Gerätepaare.
 *
 * Eine ext-Quelle (PGM, Riedel-Mic, Riedel-Speaker) wird vom Desktop in den
 * LiveKit-Room veröffentlicht (Mic-Slots) bzw. konsumiert (Spk-Slots).
 * Sobald ein Track im Room auftaucht, registriert das Backend einen
 * `ExternalPort`. Ports werden im Admin gelistet und können auf Buttons
 * gelegt werden (analog zu Panels/Partylines).
 *
 * Pairing: `ExternalDevice` koppelt einen ext-mic Port mit einem ext-spk Port
 * zu einer bidirektionalen Strecke (z.B. "Riedel A" = mic-slot-X + spk-slot-Y
 * auf demselben Desktop). Buttons vom Typ `external-device` verhalten sich
 * dann wie eine normale Intercom-Verbindung (talk+listen).
 */
/** Convenience: aus identity+slotId+kind den PortKey bauen. */
export function makePortKey(identity, kind, slotId) {
    return `${identity}::${kind}:${slotId}`;
}
/**
 * Abgeleitete LiveKit-Identitäten/PortKeys eines „Web-Intercom"-Geräts. Die
 * Browser-Seite verbindet sich als `extdev-<id>` und nutzt slotId = deviceId.
 */
export function webDevicePorts(deviceId) {
    const identity = `extdev-${deviceId}`;
    return {
        identity,
        micPortKey: makePortKey(identity, 'ext-mic', deviceId),
        spkPortKey: makePortKey(identity, 'ext-spk', deviceId),
        micTrackName: `ext-mic:${deviceId}`,
    };
}
export function parsePortKey(key) {
    const idx = key.indexOf('::');
    if (idx === -1)
        return null;
    const identity = key.slice(0, idx);
    const rest = key.slice(idx + 2);
    const colon = rest.indexOf(':');
    if (colon === -1)
        return null;
    const kindStr = rest.slice(0, colon);
    if (kindStr !== 'pgm' && kindStr !== 'ext-mic' && kindStr !== 'ext-spk')
        return null;
    return { identity, kind: kindStr, slotId: rest.slice(colon + 1) };
}
//# sourceMappingURL=external-port.js.map